export * from './timed-midi-event';
//# sourceMappingURL=/build/es2019/interfaces/index.js.map